import { Component } from '@angular/core';

@Component({
  selector: 'currency-has-relations-notification',
  styleUrls: ['./currency-has-relations-notification.component.scss'],
  templateUrl: './currency-has-relations-notification.component.html'
})
export class CurrencyHasRelationsNotificationComponent {}
